import { Tooltip } from '@neo4j-ndl/react';

export const UnknownUser = ({ userId }: { userId: string | undefined }) => {
  return (
    <Tooltip type="simple">
      <Tooltip.Trigger className="underline decoration-dotted">unknown user</Tooltip.Trigger>
      <Tooltip.Content>User {userId} was deleted or is not a project member anymore</Tooltip.Content>
    </Tooltip>
  );
};
